import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

export default class ParameterSerializer extends DataAPISerializer {}
